import {
  RECENT_PROJECT_DETAILS_BY_ID_LOADING,
  RECENT_PROJECT_DETAILS_BY_ID_SUCCESS,
  RECENT_PROJECT_DETAILS_BY_ID_FAILURE,
} from "redux/types";

const initialState = {
  projectDetailsLoading: false,
  projectDetails: null,
  errors: null,
};

export const recentProjectDetailsReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case RECENT_PROJECT_DETAILS_BY_ID_LOADING:
      return { ...state, projectDetailsLoading: action.payload };
    case RECENT_PROJECT_DETAILS_BY_ID_SUCCESS:
      return { ...state, projectDetails: action.payload };
    case RECENT_PROJECT_DETAILS_BY_ID_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
